export default __webpack_public_path__ + "static/media/banner-6.1735013c.webp";